import React, { useState, useEffect } from "react";
import "./Navbar.css";
import logo from "../Assets/Logo/onlylogosmc.png";
import PreNavbar from "../PreNavbar/PreNavbar";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isActive = (path) => window.location.pathname === path;

  // Handle scroll event
  const handleScroll = () => {
    setScrolled(window.scrollY > 50);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Toggle mobile menu
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      {" "}
      <nav className={`navbar navbar-expand-lg ${scrolled ? "scrolled" : ""}`}>
        <div className="container">
          {/* Logo and Name */}
          <a className="navbar-brand" href="/">
            <img src={logo} alt="Logo" className="navbar-logo" />
            <div className="navbar-logo-name-container">
              <span className="navbar-logo-name">
                <strong>SRIMATHI</strong>
              </span>
              <span className="consultancy">
                {" "}
                <strong>MANPOWER CONSULTANCY</strong>
              </span>
              <span className="homecare">
                <strong>Home Care Nursing Services</strong>
              </span>
            </div>
          </a>

          {/* Toggle Button for Mobile */}
          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleMenu}
            aria-controls="navbarNav"
            aria-expanded={isMenuOpen}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Collapsible Menu */}
          <div
            className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`}
            id="navbarNav"
          >
            <ul className="navbar-nav mx-auto">
              <li className="nav-item">
                <a
                  className={`nav-link ${isActive("/home") ? "active" : ""}`}
                  href="/home"
                >
                  <strong>Home</strong>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${isActive("/aboutus") ? "active" : ""}`}
                  href="/aboutus"
                >
                  <strong>About</strong>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${
                    isActive("/ourservices") ? "active" : ""
                  }`}
                  href="/ourservices"
                >
                  <strong>Services</strong>
                </a>
              </li>
              <li className="nav-item">
                <a
                  className={`nav-link ${
                    isActive("/contactus") ? "active" : ""
                  }`}
                  href="/contactus"
                >
                  <strong>Contact</strong>
                </a>
              </li>

              {/* Contact Info for Mobile */}
              <li className="nav-item d-lg-none">
                <a
                  href="tel:+919840562357"
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <i className="fas fa-phone-alt me-2"></i>
                  <strong> +91 98400 88046</strong>
                </a>
                <div style={{ fontSize: "12px" }}>
                  Call Mon-Fri 9 AM to 6 PM
                </div>
              </li>
            </ul>
          </div>

          {/* Contact Info for Desktop */}
          <div className="d-none d-lg-inline-block contact-info">
            <a
              href="tel:+919840562357"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <i className="fas fa-phone-alt me-2"></i>{" "}
              <strong>+91 98400 88046</strong>
            </a>
            <div style={{ fontSize: "12px" }}>
              <strong>Call Mon-Fri 9 AM to 6 PM</strong>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
